import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import language files
import pl from './locales/pl.json';
import en from './locales/en.json';

const resources = {
  pl: {
    translation: pl
  },
  en: {
    translation: en
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'pl', // default language (Polish)
    fallbackLng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    // Allow empty values
    returnEmptyString: false,
  });

export default i18n;